export const MobileBottomNavHeight = 44;
export const FrameHeaderHeight = 32;
export const SubHeaderHeight = 32;

export const OldFrameSidebarWidth = 0;
export const MobileFrameHeaderHeight = 40;

export const FrameBottonBarWidth = 34;
export const ViewerTopGap = 75;
export const FrameSidebarWidth = 290;
export const CADSidebarWidth = 40;
export const CADComparisonHeight = 40;
export const ConflictAlertHeight = 40;
export const NavCubWidth = 144;
export const CADSidebarWidthPx = `${CADSidebarWidth}px`;
export const CADPanelWidth = 320;
export const CameraSettingPanelWidth = 195;

export const CADGap = 6;
export const CameraSettingWrapperWidth = 140;

export const cadRoomToolbarZIndex = 9990;
